import React from 'react'
import useAgentsQuery from '../hooks/use-agents-query'
import AgentCard from './cards/agent'
import AgentSearch from './agent-search'
import { Fade } from 'react-reveal'

const Agents = () => {

  const { allWpTeam } = useAgentsQuery()

  const [list, setList] = React.useState(allWpTeam?.nodes)

  let locations = []
  let roles = []

  allWpTeam?.nodes.forEach((el, i) => {
    const office = (el.acf.office?.length > 0 && el.acf.office[0]?.title) ? el.acf.office[0].title : el.teamDetails?.officeName?.replace('CobdenHayson ', '')
    locations.push(office)
  })

  locations = locations.filter((v, i, a) => a.indexOf(v) === i)
  locations.sort()

  return (
    <section className='agents'>
      <div className='agents__inner'>
        <div className='agents__filter'>
          <AgentSearch
            list={allWpTeam?.nodes || []}
            set={setList}
            locations={locations}
          />
        </div>
        <div className='agents__items'>
          { list?.map((el) => (
            <AgentCard key={el.id} {...el} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Agents